import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../AuthContext";

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { user, loading, authRequired } = useAuth();

  // Open (dev) API: no gating.
  if (!authRequired) return <>{children}</>;

  if (loading) return <div className="centered muted">Checking access…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}
